import { render, staticRenderFns } from "./updatePerson.vue?vue&type=template&id=15e90ca9&scoped=true"
import script from "./updatePerson.vue?vue&type=script&lang=js"
export * from "./updatePerson.vue?vue&type=script&lang=js"
import style0 from "./updatePerson.vue?vue&type=style&index=0&id=15e90ca9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e90ca9",
  null
  
)

export default component.exports